import { usd, usdT } from '../../lib/format';
import type { OptionResult } from '../../types/api';

/** The three negotiating asks that close the gap to NPV = 0 (ANALYSIS.md §1). */
export function Levers({ option }: { option: OptionResult }) {
  const lv = option.levers;
  const be = option.breakeven;
  if (!lv) return null;
  if (lv.viable_at_current_prices) {
    return (
      <div className="levers">
        <div className="lever"><h3>Viable at current prices</h3><strong>{usd(option.npv_usd)}</strong><p>NPV at the {Math.round(option.wacc * 100)}% discount rate.</p></div>
        <div className="lever"><h3>Hydroxide price headroom</h3><strong>{usdT(lv.offtake_price_floor_usd_t)}</strong><p>Price below which NPV turns negative.</p></div>
        <div className="lever"><h3>Feed price headroom</h3><strong>{usdT(lv.max_feed_price_usd_t)}</strong><p>Highest SC6 price the project can pay.</p></div>
      </div>
    );
  }
  return (
    <div className="levers">
      <div className="lever">
        <h3>1 · Offtake price floor</h3>
        <strong>{usdT(lv.offtake_price_floor_usd_t)}</strong>
        <p>Ask of the cell maker. {lv.price_gap_usd_t != null && `${usdT(lv.price_gap_usd_t)} above today's benchmark.`}
          {be?.conversion_margin_usd_t != null && ` Conversion margin at breakeven ${usdT(be.conversion_margin_usd_t)}.`}</p>
      </div>
      <div className="lever">
        <h3>2 · Feed price</h3>
        <strong>{usdT(lv.max_feed_price_usd_t)}</strong>
        <p>Ask of the miner: {lv.feed_discount_needed_usd_t != null ? `a ${usdT(lv.feed_discount_needed_usd_t)} discount to the modelled SC6 price.` : 'no feed price in range makes the project viable alone.'}</p>
      </div>
      <div className="lever">
        <h3>3 · State support needed</h3>
        <strong>{usd(lv.support_needed_pv_usd)}</strong>
        <p>Additional incentives in present-value terms, on top of the package already modelled.</p>
      </div>
    </div>
  );
}
